<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <StudioGiftCheckout>
          <template v-slot:breadcrumbs="props">
            <div class="small">
              <StudioLogo class="logo-image mb-2" :studio="studio" />
              <hr class="d-block d-md-none mt-2 mb-3 p-0" />
              <router-link :to="{ name: 'studio-product' }" class="c-coral">
                <span>
                  {{ props.product.product_name }}
                </span>
              </router-link>
              <span class="mx-2 mx-md-3"
                ><i class="fal fa-chevron-right"></i
              ></span>
              <span class="c-charcoal">{{
                $t('STUDIO.LABELS.GIVE_AS_GIFT')
              }}</span>
            </div>
          </template>
        </StudioGiftCheckout>
      </div>
    </div>
  </div>
</template>

<script>
import StudioGiftCheckout from '@/web/components/checkout/StudioGiftCheckout';
import StudioLogo from '@/web/components/navigation/StudioLogo';
import { mapGetters } from 'vuex';

export default {
  name: 'StudioProductCheckout',
  components: {
    StudioGiftCheckout,
    StudioLogo,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.logo-image {
  display: block;
  height: 60px;
  width: auto;
}
</style>
